var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import * as moment from 'moment-timezone';
import CalendarTile from './CalendarTile';
import { GridContent } from '@doordash/component-grid';
import { CalendarGrid } from './CalendarStyles';
import { getDaysFromStartOfWeek, getTodayDateTimeInSelectedTimeZone, getHasGoEntriesOnWeekends, } from './CalendarHelper';
import { useOfficeContext } from '../../GroupOrdersCalendarContext';
import { useListGroupOrderEntries } from '../../../../../hooks/useListGroupOrderEntries';
import { DEFAULT_TIMEZONE } from '../../../../../constants/values';
import DeleteGroupOrderEntryModal from './DeleteGroupOrderEntryModal';
import { useDeleteGroupOrderEntry } from '../../../../../hooks/useDeleteGroupOrderEntry';
import { useCalendarViewContext } from './CalendarViewContext';
import { GroupOrdersAdminEvents } from '../../../../../constants/events';
import track from '../../../../../utils/track';
import Loading from '@doordash/component-loading';
import { getDateRangeForListGoEntries } from '../../utils/getDateRangeForListGoEntries';
var CalendarBiweeklyView = function (_a) {
    var _b, _c;
    var onNewOrderDateSelect = _a.onNewOrderDateSelect, calendarInfo = _a.calendarInfo, showWeekendsView = _a.showWeekendsView, setShowWeekendsView = _a.setShowWeekendsView;
    var _d = __read(React.useState(false), 2), isDeleteGoEntryModalOpen = _d[0], setIsDeleteGoEntryModalOpen = _d[1];
    var _e = __read(React.useState(null), 2), selectedEntry = _e[0], setSelectedEntry = _e[1];
    var selectedOffice = useOfficeContext().selectedOffice;
    var isEmployeeView = useCalendarViewContext().isEmployeeView;
    var _f = isEmployeeView
        ? {
            teamAccountId: calendarInfo.teamAccountId,
            officeId: calendarInfo.officeId,
            officeTimeZone: calendarInfo.timezone,
        }
        : {
            teamAccountId: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.teamAccountId,
            officeId: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.id,
            officeTimeZone: (selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.address.timezone) || DEFAULT_TIMEZONE,
        }, teamAccountId = _f.teamAccountId, officeId = _f.officeId, officeTimeZone = _f.officeTimeZone;
    var _g = getDateRangeForListGoEntries(officeTimeZone), startDate = _g.startDate, endDate = _g.endDate;
    var _h = useListGroupOrderEntries(teamAccountId, officeId, startDate, endDate), data = _h.data, isEntriesLoading = _h.loading;
    var savedShowWeekendsSetting = ((_b = data === null || data === void 0 ? void 0 : data.listGroupOrderEntries) === null || _b === void 0 ? void 0 : _b.showWeekends) || false;
    var officeCurrentDateTime = getTodayDateTimeInSelectedTimeZone(officeTimeZone);
    var goEntries = ((_c = data === null || data === void 0 ? void 0 : data.listGroupOrderEntries) === null || _c === void 0 ? void 0 : _c.groupOrderEntries) || [];
    var hasGoEntriesOnWeekends = getHasGoEntriesOnWeekends(goEntries);
    var skippedDaysForEmployeeView = hasGoEntriesOnWeekends ? [] : [6, 7];
    var skippedDaysForAdminView = showWeekendsView ? [] : [6, 7];
    var skippedDays = isEmployeeView
        ? skippedDaysForEmployeeView
        : skippedDaysForAdminView;
    // get 14 days DateInfo, skip Saturdays and Sundays when showWeekends view is disabled (default view)
    var dateList = getDaysFromStartOfWeek(14, skippedDays, officeCurrentDateTime.date);
    // update the calendar view with the saved setting
    React.useEffect(function () {
        if (isEmployeeView) {
            setShowWeekendsView(hasGoEntriesOnWeekends);
        }
        else {
            setShowWeekendsView(savedShowWeekendsSetting);
        }
    }, [
        savedShowWeekendsSetting,
        setShowWeekendsView,
        isEmployeeView,
        hasGoEntriesOnWeekends,
    ]);
    var deleteGoEntry = useDeleteGroupOrderEntry().deleteGoEntry;
    var closeDeleteEntryModal = function () { return setIsDeleteGoEntryModalOpen(false); };
    var showDeleteGoEntryConfirmation = function (entry) {
        setIsDeleteGoEntryModalOpen(true);
        setSelectedEntry(entry);
    };
    var handleOnDeleteEntry = function () {
        var _a, _b;
        track(GroupOrdersAdminEvents.ADMIN_CALENDAR_CANCEL_GROUP_ORDER, {
            team_account_id: teamAccountId,
            cart_id: (_a = selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.cart) === null || _a === void 0 ? void 0 : _a.id,
            store_id: (_b = selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.store) === null || _b === void 0 ? void 0 : _b.id,
        });
        deleteGoEntry(selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.id, teamAccountId);
    };
    if (isEntriesLoading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        isDeleteGoEntryModalOpen && (React.createElement(DeleteGroupOrderEntryModal, { onClose: closeDeleteEntryModal, handleOnDeleteEntry: handleOnDeleteEntry })),
        React.createElement(CalendarGrid, { showWeekendsView: showWeekendsView }, dateList.map(function (dateInfo) {
            var selectedDateGoEntries;
            if ((goEntries === null || goEntries === void 0 ? void 0 : goEntries.length) > 0) {
                selectedDateGoEntries = goEntries.find(function (entry) {
                    return moment(entry === null || entry === void 0 ? void 0 : entry.date).isSame(moment(dateInfo.formattedDate));
                });
            }
            return (React.createElement(GridContent, { key: dateInfo.formattedDate + "-" + officeId },
                React.createElement(CalendarTile, { officeCurrentDateTime: officeCurrentDateTime, dateInfo: dateInfo, goEntries: selectedDateGoEntries, onNewOrderClick: onNewOrderDateSelect, onDeleteEntry: showDeleteGoEntryConfirmation })));
        }))));
};
export default CalendarBiweeklyView;
